<template>
  <main class="project-gradient h-full" :style="{'--dominant': dominant, '--average': average }" v-if="project">  
    <div v-if="slides.length > 0" class="relative h-full transition duration-1000" :class="{ 'opacity-20': showinfo }">
            <transition-group name="fadeimg-fast" mode="out-in">
                  <div 
                        ref="slides"
                        v-for="(file, index) in slides"
                        :key="file.uid + '–' + index"
                        :data-dominant="file.dominant"
                        :data-average="file.average"
                        class="absolute top-0 left-0 w-full h-full p-12 pb-16 text-center" 
                        v-show="sIndex == index"
                        >
                        <img v-if="file.type == 'image'"  :data-imgsize="file.imgsize" :src="file.thumb" :srcset="file.srcset" class="w-full h-full object-contain" />
                        <video class="w-full h-full object-contain" v-if="file.type == 'video'" autoplay muted loop playsinline :src="file.url"></video>
                  </div>
      </transition-group>
        <div @click="prev" class="group absolute cursor-pointer z-10 top-0 left-0 p-4 w-1/2 md:w-1/4 h-full text-base md:text-lg">
            <div aria-label="Previous image" role="button" tabindex="0" @keydown.enter.self="prev" class="opacity-0 focus:opacity-100 select-none md:group-hover:opacity-100 transition md:duration-800 absolute top-1/2">
                  Previous 
            </div>
        </div>  

        <div @click="next" class="group absolute cursor-pointer z-10 top-0 right-0 p-4 w-1/2 md:w-1/4 h-full text-base md:text-lg">
            <div aria-label="Next image" role="button" tabindex="0" @keydown.enter.self="next" class="opacity-0 focus:opacity-100 select-none md:group-hover:opacity-100 transition duration-800 absolute text-right right-4 top-1/2">
                  Next
            </div>
        </div> 
    </div> 


    <div class="group z-20 transition duration-800 p-4 pt-20 fixed left-0 bottom-0 w-full text-base md:text-lg grid grid-cols-1 md:grid-cols-6 items-end leading-tight" :class="{ 'opacity-0 lg:opacity-100': showinfo }">
            <div class="opacity-100 col-start-1 col-span-1">
            {{ project.title }}
            </div>
            <div class="md:opacity-100 transition duration-300  md:col-start-2 md:col-span-1 capitalize">
            {{ project.category }}
            </div>
            <div class="md:opacity-100 transition duration-300 md:col-start-3 md:col-span-1">
            {{ project.year }} 
            </div>  
            <div role="button" tabindex="0" v-if="!showinfo && project.description.length > 0" @click="showinfo = true" @keydown.enter.self="showinfo = true" class="cursor-pointer">More</div>
            <div v-if="showinfo && project.description.length > 0" class="cursor-pointer" @click="showinfo = false" @keydown.enter.self="showinfo = false" >Close</div>
      </div>   

      <div @click="showinfo = false" class="absolute transform top-0 left-1/2 -translate-x-1/2 w-full lg:w-auto px-4 h-full flex flex-col justify-center transition duration-500" :class="{ 'visible opacity-100': showinfo && project.description.length > 0, 'opacity-0 invisible': !showinfo }">
            <div class="py-24 lg:py-16 max-h-full overflow-y-auto no-scrollbar" v-html="project.description"></div>
      </div>

  </main>
</template>

<script>
export default {
  name: "project",
  metaInfo() {
    return {
      title: "– " + this.project.title,
    };
  },
  data() {
    return {
      sIndex: 0,
      dominant: '#FFF',
      average: '#FFF',
      showinfo: false
    }
  },
  mounted() {
    let colors = this.$refs.slides[this.sIndex].dataset.dominant.split(',');
    this.dominant = colors[0];
    this.average = colors[1] ?? this.$refs.slides[this.sIndex].dataset.average;
    document.body.classList.add('project-view');
  },
  destroyed() {
      document.body.classList.remove('project-view');
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
    slides() {
      return this.project.videos.concat(this.project.images)
    }
  },
  methods: {
    next() {
      if(this.sIndex == this.slides.length - 1) {
        this.sIndex = 0
      } else {
        this.sIndex++;
      }
      let colors = this.$refs.slides[this.sIndex].dataset.dominant.split(',');
      this.dominant = colors[0];
      this.average = colors[1] ?? this.$refs.slides[this.sIndex].dataset.average;
    },
    prev() {
      if(this.sIndex == 0) {
        this.sIndex = this.slides.length - 1
      } else {
        this.sIndex--;
      }
      let colors = this.$refs.slides[this.sIndex].dataset.dominant.split(',');
      this.dominant = colors[0];
      this.average = colors[1] ?? this.$refs.slides[this.sIndex].dataset.average;
    }
  }
};
</script>